import { CallApiOptions } from './api';
import { NewIdol } from '../modules/IdolCreate/index';

export const fetchIdolsCallOptions = (): CallApiOptions => ({
  method: 'GET',
  endpoint: `idols`,
  params: {
    limit: 2999 ,
  },
});

export const saveIdolCallOptions = (idol: NewIdol): CallApiOptions => {
  const { name, gender, appIds, quality, qualities, images } = idol;

  return {
    method: 'POST',
    endpoint: 'idols',
    body: JSON.stringify({
      name,
      gender,
      appIds,
      quality,
      qualities,
      images
    }),
  };
};

export const updateIdolCallOptions = (idol: NewIdol): CallApiOptions => {
  const { name, gender, appIds, id, quality, qualities, images } = idol;
  return {
    method: 'PUT',
    endpoint: `idols/${id}`,
    body: JSON.stringify({
      name,
      gender,
      appIds,
      quality,
      qualities,
      images
    }),
  };
};



// WEBPACK FOOTER //
// ./src/services/idols.service.ts